'use strict';

var levelup = require('levelup');

var encode = require('encoding-down');

function packager(leveldown) {
  function Level(location, options, callback) {
    if (typeof location === 'function') {
      callback = location;
    } else if (typeof options === 'function') {
      callback = options;
    }

    if (!isObject(options)) {
      options = isObject(location) ? location : {};
    }

    return levelup(encode(leveldown(location, options), options), options, callback);
  }

  function isObject(o) {
    return typeof o === 'object' && o !== null;
  }

  var _loop = function _loop() {
    var m = _arr[_i];

    if (typeof leveldown[m] === 'function') {
      Level[m] = function () {
        leveldown[m].apply(leveldown, arguments);
      };
    }
  };

  for (var _i = 0, _arr = ['destroy', 'repair']; _i < _arr.length; _i++) {
    _loop();
  }

  Level.errors = levelup.errors;
  return Level;
}

module.exports = packager;